/* Aurekto Card Studio — rebuilt 2026-08.
   Variant ID comes exclusively from [data-double-variant] (rendered from the
   shop metafield aurekto.card_variant_double). The cart/add.js payload is
   logged to the console before every request for fast debugging, and error
   messages include the variant ID that failed. */
(function () {
  'use strict';
  if (window.__aurektoCardStudio) return;
  window.__aurektoCardStudio = true;

  var FRAME_W = 220, FRAME_H = 340, EX_W = 650, EX_H = 1004, LOW_W = 500;
  var CLOUDINARY_FOLDER = 'aurekto/cards';

  /* English fallbacks — real strings come from the [data-acs-i18n] JSON rendered by Liquid locale files. */
  var T_FALLBACK = {
    tooBig: 'Please upload an image under 10MB.',
    badImage: "We couldn't read that image.",
    uploadFirst: 'Please upload a photo first.',
    uploading: 'Uploading your card…',
    added: 'Added to bag.',
    error: 'Something went wrong: ',
    gateSoon: 'Custom cards are coming soon — please check back shortly.',
    gatePhoto: 'Upload a photo to add this to your bag.',
    gateAgree: 'Please confirm the copyright notice to add this to your bag.'
  };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initAll() { $$('[data-acs]').forEach(initStudio); }

  function initStudio(root) {
    if (root.dataset.inited) return;
    root.dataset.inited = '1';

    var T = T_FALLBACK;
    var i18nEl = $('[data-acs-i18n]', root);
    if (i18nEl) {
      try { T = Object.assign({}, T_FALLBACK, JSON.parse(i18nEl.textContent)); } catch (err) {}
    }

    var cfg = {
      double: (root.dataset.doubleVariant || '').trim(),
      cloud: (root.dataset.cloud || '').trim(),
      preset: (root.dataset.preset || '').trim()
    };
    var configured = !!(cfg.cloud && cfg.preset && /^\d+$/.test(cfg.double));
    if (!configured) console.warn('[aurekto-card-studio] not configured', cfg);

    var form = (function () {
      var scope = root.closest('.aurekto-buybox') || root.closest('.product__info-container') || document;
      return scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    })();
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;

    /* All custom cards are made & shipped — no self-print path in the purchase flow. */
    var st = { type: 'none', img: null, iw: 0, ih: 0, zoom: 1, ox: 0, oy: 0, msg: '', agreed: false, busy: false, gated: false, wasDisabled: submitBtn ? submitBtn.disabled : false };

    var panel = $('[data-acs-panel]', root);
    var canvas = $('[data-acs-canvas]', root);
    var ctx = canvas.getContext('2d');
    var backWrap = $('[data-acs-backwrap]', root);
    var backCanvas = $('[data-acs-back]', root);
    var backCtx = backCanvas.getContext('2d');
    var fileInput = $('[data-acs-file]', root);
    var zoomInput = $('[data-acs-zoom]', root);
    var msgInput = $('[data-acs-msg]', root);
    var msgCount = $('[data-acs-count]', root);
    var msgWrap = $('[data-acs-msgwrap]', root);
    var lowres = $('[data-acs-lowres]', root);
    var madeBlock = $('[data-acs-made]', root);
    var agreeInput = $('[data-acs-agree]', root);
    var statusEl = $('[data-acs-status]', root);
    var gateHint = $('[data-acs-gatehint]', root);
    var stageWrap = $('[data-acs-stagewrap]', root);

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = FRAME_W * dpr; canvas.height = FRAME_H * dpr;
    backCanvas.width = FRAME_W * dpr; backCanvas.height = FRAME_H * dpr;

    function baseScale() { return Math.max(FRAME_W / st.iw, FRAME_H / st.ih); }

    function clampPos() {
      var s = baseScale() * st.zoom;
      var maxX = Math.max(0, (st.iw * s - FRAME_W) / 2);
      var maxY = Math.max(0, (st.ih * s - FRAME_H) / 2);
      st.ox = Math.min(maxX, Math.max(-maxX, st.ox));
      st.oy = Math.min(maxY, Math.max(-maxY, st.oy));
    }

    function updateLowres() {
      if (!st.img) return;
      var usedW = FRAME_W / (baseScale() * st.zoom);
      lowres.hidden = usedW >= LOW_W;
    }

    function setZoom(z) {
      st.zoom = Math.min(3, Math.max(1, z));
      zoomInput.value = Math.round(st.zoom * 100);
      clampPos();
      updateLowres();
      drawFront(ctx);
    }

    function drawFront(c) {
      var f = c.canvas.width / FRAME_W;
      c.fillStyle = '#ffffff';
      c.fillRect(0, 0, c.canvas.width, c.canvas.height);
      if (!st.img) return;
      var s = baseScale() * st.zoom * f;
      var dw = st.iw * s, dh = st.ih * s;
      c.drawImage(st.img, (c.canvas.width - dw) / 2 + st.ox * f, (c.canvas.height - dh) / 2 + st.oy * f, dw, dh);
    }

    function wrapLine(c, text, maxW) {
      var out = [], line = '';
      text.split(/\s+/).forEach(function (word) {
        if (!word) return;
        var t = line ? line + ' ' + word : word;
        if (c.measureText(t).width > maxW && line) { out.push(line); line = word; } else { line = t; }
      });
      if (line) out.push(line);
      if (!out.length) out.push('');
      return out;
    }

    function wrapText(c, text, maxW) {
      var out = [];
      text.split(/\n/).forEach(function (seg) {
        wrapLine(c, seg, maxW).forEach(function (l) { out.push(l); });
      });
      return out.slice(0, 8);
    }

    function drawBack(c) {
      var W = c.canvas.width, H = c.canvas.height, u = W / EX_W;
      c.fillStyle = '#ffffff'; c.fillRect(0, 0, W, H);
      c.strokeStyle = '#b08d57'; c.lineWidth = Math.max(1, 2.5 * u);
      c.strokeRect(30 * u, 30 * u, W - 60 * u, H - 60 * u);
      var msg = (st.msg || '').replace(/\s+$/, '');
      c.fillStyle = '#211d19';
      c.font = 'italic ' + Math.round(44 * u) + 'px Georgia, serif';
      c.textAlign = 'center'; c.textBaseline = 'middle';
      if (msg.trim()) {
        var lines = wrapText(c, msg, W * 0.68);
        var lh = 66 * u;
        var y0 = H / 2 - ((lines.length - 1) * lh) / 2;
        lines.forEach(function (ln, i) { c.fillText(ln, W / 2, y0 + i * lh); });
      } else {
        c.fillStyle = 'rgba(33,29,25,.3)';
        c.fillText('—', W / 2, H / 2);
      }
      c.fillStyle = '#b08d57';
      c.font = Math.round(26 * u) + 'px Georgia, serif';
      c.fillText('A U R E K T O', W / 2, H - 96 * u);
    }

    function exportCanvas(kind) {
      var off = document.createElement('canvas');
      off.width = EX_W; off.height = EX_H;
      var c = off.getContext('2d');
      if (kind === 'front') {
        var f = EX_W / FRAME_W, s = baseScale() * st.zoom * f;
        c.fillStyle = '#ffffff'; c.fillRect(0, 0, EX_W, EX_H);
        c.drawImage(st.img, (EX_W - st.iw * s) / 2 + st.ox * f, (EX_H - st.ih * s) / 2 + st.oy * f, st.iw * s, st.ih * s);
      } else {
        drawBack(c);
      }
      return off;
    }

    function toBlob(cv, mime, quality) {
      return new Promise(function (res, rej) {
        cv.toBlob(function (b) { b ? res(b) : rej(new Error('export failed')); }, mime || 'image/png', quality);
      });
    }

    function uploadBlob(blob) {
      var fd = new FormData();
      fd.append('file', blob);
      fd.append('upload_preset', cfg.preset);
      fd.append('folder', CLOUDINARY_FOLDER);
      return fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cfg.cloud) + '/image/upload', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j.error && j.error.message) || ('upload ' + r.status)); }, function () { throw new Error('upload ' + r.status); });
          return r.json();
        })
        .then(function (j) { return j.secure_url; });
    }

    function setStatus(msg, isError) {
      statusEl.textContent = msg || '';
      statusEl.classList.toggle('is-error', !!isError);
    }

    function refresh() {
      panel.hidden = st.type === 'none';
      msgWrap.hidden = st.type !== 'double';
      backWrap.hidden = st.type !== 'double';
      if (madeBlock) madeBlock.hidden = st.type === 'none';
      if (stageWrap) stageWrap.hidden = !st.img;
      $$('.acs__opt', root).forEach(function (o) { o.classList.toggle('is-on', o.querySelector('input').checked); });
      drawFront(ctx);
      if (st.type === 'double') drawBack(backCtx);
      updateGate();
    }

    function updateGate() {
      if (!submitBtn) return;
      var need = st.type !== 'none';
      var blocked = need && (!st.img || !st.agreed || !configured || st.busy);
      if (blocked) {
        if (!st.gated) { st.wasDisabled = submitBtn.disabled; st.gated = true; }
        submitBtn.disabled = true;
        gateHint.hidden = false;
        gateHint.textContent = !configured ? T.gateSoon : (!st.img ? T.gatePhoto : T.gateAgree);
      } else {
        if (st.gated) { submitBtn.disabled = st.wasDisabled; st.gated = false; }
        gateHint.hidden = true;
      }
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-acs-type-input]')) { st.type = t.value; refresh(); }
      if (t === agreeInput) { st.agreed = agreeInput.checked; updateGate(); }
    });

    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return;
      if (f.size > 10 * 1024 * 1024) { setStatus(T.tooBig, true); fileInput.value = ''; return; }
      var url = URL.createObjectURL(f);
      var img = new Image();
      img.onload = function () {
        st.img = img; st.iw = img.naturalWidth; st.ih = img.naturalHeight;
        st.zoom = 1; st.ox = 0; st.oy = 0;
        zoomInput.value = 100;
        updateLowres();
        setStatus('');
        refresh();
        URL.revokeObjectURL(url);
      };
      img.onerror = function () { setStatus(T.badImage, true); };
      img.src = url;
    });

    zoomInput.addEventListener('input', function () {
      setZoom(parseInt(zoomInput.value, 10) / 100);
    });

    /* drag + pinch (Pointer Events) and wheel zoom */
    var pointers = new Map();
    var drag = null;
    var pinch = null;

    function pinchDist() {
      var pts = Array.from(pointers.values());
      return Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (!st.img) return;
      canvas.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        pinch = { dist: pinchDist(), zoom: st.zoom };
        drag = null;
      } else if (pointers.size === 1) {
        drag = { x: e.clientX, y: e.clientY, ox: st.ox, oy: st.oy };
      }
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pinch && pointers.size === 2) {
        var d = pinchDist();
        if (pinch.dist > 0) setZoom(pinch.zoom * (d / pinch.dist));
      } else if (drag) {
        st.ox = drag.ox + (e.clientX - drag.x);
        st.oy = drag.oy + (e.clientY - drag.y);
        clampPos();
        drawFront(ctx);
      }
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      canvas.addEventListener(ev, function (e) {
        pointers.delete(e.pointerId);
        if (pointers.size < 2) pinch = null;
        if (pointers.size === 0) drag = null;
      });
    });
    canvas.addEventListener('wheel', function (e) {
      if (!st.img) return;
      e.preventDefault();
      setZoom(st.zoom + (e.deltaY < 0 ? 0.08 : -0.08));
    }, { passive: false });

    if (msgInput) msgInput.addEventListener('input', function () {
      st.msg = msgInput.value.slice(0, 60);
      msgCount.textContent = st.msg.length + ' / 60';
      drawBack(backCtx);
    });

    /* Intercept at DOCUMENT capture so this runs before Dawn's product-form
       submit handler (registered directly on the form earlier in page load).
       Without this, product-form would add the bare main product first and the
       studio would add it again with the add-on — a duplicate line item. */
    if (form) document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (st.type === 'none' || st.busy) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!st.img || !st.agreed || !configured) { updateGate(); return; }
      st.busy = true; updateGate();
      if (submitBtn) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.disabled = true; }
      setStatus(T.uploading);

      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var mainId = idInput ? parseInt(idInput.value, 10) : null;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var addonId = parseInt(cfg.double, 10);

      /* Uploads are JPEG (quality .95) — some Cloudinary presets restrict PNG; print quality is unaffected. */
      var uploads = [
        toBlob(exportCanvas('front'), 'image/jpeg', 0.95).then(uploadBlob),
        toBlob(exportCanvas('back'), 'image/jpeg', 0.95).then(uploadBlob)
      ];

      Promise.all(uploads).then(function (urls) {
        var props = {
          _card_type: 'double',
          _front_url: urls[0],
          _back_message: st.msg,
          _back_url: urls[1],
          _copyright_agreed: 'yes|' + new Date().toISOString()
        };
        var items = [{ id: mainId, quantity: qty }, { id: addonId, quantity: 1, properties: props }];
        var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        console.log('[aurekto-card-studio] cart/add.js payload', JSON.stringify(body));
        return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().then(function (j) {
            if (r.status >= 400 || j.status) {
              console.error('[aurekto-card-studio] cart/add.js error', r.status, j);
              throw new Error((j.description || j.message || 'cart error') + ' (' + addonId + ')');
            }
            return { json: j, cartEl: cartEl };
          });
        });
      }).then(function (res) {
        setStatus(T.added);
        try { if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'aurekto-card-studio' }); } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        /* Drawer refresh must never fail silently: if section re-render throws
           (e.g. a section element missing on this template), fall back to /cart
           so the customer always sees what was added. */
        if (res.cartEl && typeof res.cartEl.renderContents === 'function' && res.json.sections) {
          try {
            res.cartEl.renderContents(res.json);
          } catch (renderErr) {
            console.error('[aurekto-card-studio] drawer render failed, redirecting to /cart', renderErr);
            window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
          }
        } else {
          window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
        }
      }).catch(function (err) {
        setStatus(T.error + err.message, true);
      }).finally(function () {
        st.busy = false;
        if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.disabled = false; }
        updateGate();
      });
    }, true);

    refresh();
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
